export default "__VITE_ASSET__9kXSU9nd__"